import React from 'react';

import useFilter from '../../utilities/useFilter';
import InlineEditorWrapper from '../../utilities/InlineEditorWrapper';
import ListView from '../shared/lists/ListView';
import Row from 'react-bootstrap/Row';
import SortableTh from '../shared/table/SortableTh';
import Col from 'react-bootstrap/Col';
import ApiTokenItem from './ApiTokenItem';
import ApiTokenEditor from './ApiTokenEditor';

const ApiTokenView = (props) => {
    const getUrl = '/api/apitokens/list';
    const postUrl = `/api/apitokens/edit`;
    const editUrl = `/api/apitokens/edit/`;
    const deleteUrl = `/api/apitokens/delete`;
    const defaultFilter = {
        sortColumn: 'Name'
    }

    const { items, filter, setData, submitFilter, pageInfo, isLoaded } = useFilter(getUrl, defaultFilter, true);

    const canAdd = items.filter(i => i.id === 0).length === 0;

    function addNew() {
        const currentData = JSON.parse(JSON.stringify(items));
        if (canAdd) {
            currentData.push({
                id: 0,
                franchiseId: 0,
                appUserId: 0
            });
            setData(currentData);
        }
    }

    const tableHead = (
        <thead className="table-index-head">
            <tr>
                <SortableTh sortName="Name" sort={pageInfo}>Name</SortableTh>
                <SortableTh sortName="FranchiseName" sort={pageInfo}>Franchise</SortableTh>
                <SortableTh sortName="AppUserFirstName" sort={pageInfo}>User</SortableTh>
                <th style={{ width: "310px" }}>Api Token</th>
                <th style={{ width: "98px" }}>&nbsp;</th>
            </tr>
        </thead>
    );

    const apiTokens = items.map((item) =>
        <InlineEditorWrapper
            isNew={item.id === 0}
            key={item.id}
            editItem={props.editItem}
        >
            <ApiTokenItem
                item={item}
                fetchData={submitFilter}
                deleteUrl={deleteUrl}
            />
            <ApiTokenEditor
                item={item}
                getUrl={editUrl + item.id}
                postUrl={postUrl}
                fetchData={submitFilter}
                cancelEdit={submitFilter}
                franchiseId={filter.franchiseId}
            />
        </InlineEditorWrapper>
    );

    return (
        <Row>
            <Col>
                <ListView
                    animate={false}
                    items={apiTokens || []}
                    tableHead={tableHead}
                    canAdd={canAdd}
                    itemName="Api Token"
                    addItem={addNew}
                    isLoaded={isLoaded}
                    pageInfo={pageInfo} />
            </Col>
        </Row>
    );
}

export default ApiTokenView;